import { inject } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { Observable, finalize } from 'rxjs';
import { LoaderService } from '@services/loader/loader.service';

export class LoaderInterceptor implements HttpInterceptor {

  loadingService = inject(LoaderService);
  totalRequests = 0;
  
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const loadingService = inject(LoaderService);
    const noSpinner = req.headers.has('No-Spinner');

    if (!noSpinner) {
      this.totalRequests++;
      loadingService.setLoading(true);
    }
    
    return next.handle(req).pipe(
      finalize(() => {
        this.totalRequests--;
        if (this.totalRequests === 0) {
          loadingService.setLoading(false);
        }
      })
    );
  }
}